import { createClient } from '@supabase/supabase-js';
import { env } from './env';
import type { Database } from './database.types';

/**
 * קליינט אחד לכל האפליקציה. הדפדפן מדבר ישירות עם Supabase,
 * וההגנה היא RLS ופונקציות security definer (מסמך התכנון, סעיף 1).
 */
export const supabase = createClient<Database>(env.supabaseUrl, env.supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    flowType: 'pkce',
  },
});
